import { render, staticRenderFns } from "./ResourceDetail.vue?vue&type=template&id=3cc2fd4a&"
import script from "./ResourceDetail.vue?vue&type=script&lang=js&"
export * from "./ResourceDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports